import { ReactNode, useMemo, useState } from 'react';
import { HeaderContext } from './HeaderContext';
import { PlanBillingNotice } from './PlanBillingNotice';

export function HeaderProvider({ children }: { children: ReactNode }) {
  const [headerContent, setHeaderContent] = useState<ReactNode>(null);
  const [isLoading, setLoading] = useState<boolean>(false);

  const contextValue = useMemo(
    () => ({
      headerContent,
      setHeaderContent,
      isLoading,
      setLoading,
    }),
    [headerContent, isLoading],
  );

  return (
    <HeaderContext.Provider value={contextValue}>
      <PlanBillingNotice />
      {children}
    </HeaderContext.Provider>
  );
}
